import React from "react";
import useListContext from "../../tools/useListContext";
import {ModelsRepository} from "../../repository/AdminDashboard/DeviceModelRepository";
import toast from "react-hot-toast";
import {useModal} from "../../tools/useModal";

const modelsContext = React.createContext();

const ModelsContextProvider = ({children}) => {
    const {
        handleUpdateListState,
        listState,
        onDevicePerPageChange,
        changePage,
        onSearchBtnClick,
    } = useListContext(getModels)

    const {closeModal, openModal, modalState} = useModal();

    async function getModels() {
        handleUpdateListState("loading", true)
        const response = await ModelsRepository.getModelsList(listState.searchQuery, listState.pageNumber);
        handleUpdateListState("loading", false)

        if (response.code !== 1) {
            toast.error(response.massage, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }

        handleUpdateListState("list", response.ModelsClassList)
        handleUpdateListState("countAll", response.countAllPages)
    }

    async function deleteDeviceModel() {

        const response = await ModelsRepository.delete(modalState.selectedItem.id);
        if (response.code !== 1) {
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        closeModal()
        await getModels();
    }



    return (<modelsContext.Provider value={{
        openModal,
        closeModal,
        deleteDeviceModel,
        listState,
        modalState,
        onSearchBtnClick,
        changePage
    }}>
        {children}
    </modelsContext.Provider>)
}


export function useModelsContext() {
    return React.useContext(modelsContext)
}
export {ModelsContextProvider};
